import { useContext } from "react";
import {
  NutritionPlanContext,
  NutritionPlanContextValue,
} from "./NutritionPlanProvider";

/** Read the nutrition plan store. Throws outside `NutritionPlanProvider`, like `useSubject`. */
export const useNutritionPlan = (): NutritionPlanContextValue => {
  const value = useContext(NutritionPlanContext);
  if (!value) {
    throw new Error(
      "useNutritionPlan must be used within NutritionPlanProvider"
    );
  }
  return value;
};

export default useNutritionPlan;
